import Alpine from "alpinejs";

export default function Menu(lenis) {
  const menuItems = document.querySelectorAll(".navbar__menuitem");
  const menuSubs = document.querySelectorAll(".navbaritem");

  let subBg = document.querySelector(".navbar__bg"),
    subArr = document.querySelector(".navbar__bg .arrow"),
    navbar = document.querySelector(".navbar"),
    btnMenu = document.querySelector(".menuButton"),
    closeDropdownTimeout,
    startCloseTimeout = (el) => {
      menuSubs.forEach((el) => {
        el.style.setProperty("transition-duration", "200ms");
      });
      closeDropdownTimeout = setTimeout(() => closeDropdown(el), 10);
    },
    stopCloseTimeout = function () {
      clearTimeout(closeDropdownTimeout);
    },
    closeDropdown = (el) => {
      subArr.style.top = '-2rem';
      subBg.style.opacity = 0;
      el.classList.remove("menu--opened");

      //- Remove active class from all sub menus
      menuSubs.forEach((el) => {
        el.style.opacity = 0;
        el.style.setProperty("pointer-events", "none");
      });
    },
    openDropdown = (el) => {
      let subMenu = el.querySelector(".navbaritem");
      let subMeta = subMenu.getBoundingClientRect();
      let navbarMeta = navbar.getBoundingClientRect();

      menuSubs.forEach((el) => {
        el.style.opacity = 0;
        el.style.setProperty("pointer-events", "none");
      });

      subArr.style.top = "-0.9rem";
      subBg.style.opacity = 1;
      subMenu.style.opacity = 1;
      subMenu.style.setProperty("pointer-events", "auto");
      subMenu.style.setProperty("transition-duration", "400ms");
      subBg.style.width = `${subMeta.width}px`;
      subBg.style.height = `${subMeta.height}px`;
      subBg.style.setProperty(
        "transform",
        `translateX(${subMeta.left - navbarMeta.left}px)`
      );

      el.classList.add("menu--opened");
    };

  if (navbar) {
    menuItems.forEach((el) => {
      el.addEventListener("mouseenter", function () {
        if (this.getAttribute("data-sub") === "true") {
          stopCloseTimeout();
          openDropdown(this);
        } else closeDropdown(this);
      });
  
      el.addEventListener(
        "mouseleave",
        function () {
          startCloseTimeout(this);
        },
        false
      );

      el.querySelector("a").addEventListener(
        "click",
        function (e) {
        //   e.preventDefault()
          const event = window.event || e

          if (this === event.target) {
            if (el.getAttribute("data-sub") === "true") {
              if (el.classList.contains("menu--opened")) startCloseTimeout(el);
              else {
                stopCloseTimeout();
                openDropdown(el);
              }
            }
          }
        },
        false
      );
    });
  
    document.addEventListener("alpine:init", () => {
      // toggle action with Alpine
      Alpine.store("toggleMobile", {
        show: false,
        toggle() {
          this.show = !this.show;
  
          if (this.show === true)
            lenis.stop();
          else {
            lenis.start();
            Alpine.store("openedSubmenu").close();
          }
        },
      });
  
      Alpine.store("openedSubmenu", {
        selected: null,
        open(index) {
          this.selected = index;
        },
        close() {
          this.selected = null;
        },
      });
    });
    
    const navsubmenu = document.querySelector('.navbar__mobilesub--menu')
    if (navsubmenu) {
      navsubmenu.addEventListener('wheel', (event) => event.stopPropagation());
      if("ontouchstart" in window){
        navsubmenu.addEventListener('touchstart', (event) => event.stopPropagation());
        navsubmenu.addEventListener('touchmove', (event) => event.stopPropagation());
        navsubmenu.addEventListener('touchend', (event) => event.stopPropagation());
      }
    }
  }
}
